
(() => {
  if (window.__xbCartSyncInstalled) return;
  window.__xbCartSyncInstalled = true;

  const ADD_URL = /\/cart\/add(?:\.js)?(?:\?|$)/i;
  const SECTION_ID = 'cart-drawer-section';

  let refreshTimer;
  let refreshInProgress = false;
  let refreshAgain = false;

  async function refreshCartDrawer() {
    if (refreshInProgress) {
      refreshAgain = true;
      return;
    }

    refreshInProgress = true;

    try {
      const url = new URL(window.location.href);
      url.searchParams.set('sections', SECTION_ID);
      url.searchParams.set('_xb_sync', Date.now().toString());

      const response = await fetch(url.toString(), {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) {
        throw new Error(`Cart section request failed: ${response.status}`);
      }

      const sections = await response.json();
      const html = sections[SECTION_ID];

      if (!html) {
        throw new Error('Shopify returned no cart drawer section HTML.');
      }

      const parsed = new DOMParser().parseFromString(html, 'text/html');

      const incomingDrawer = parsed.querySelector(
        '#cart-drawer-section cart-drawer-component'
      ) || parsed.querySelector('cart-drawer-component');

      const currentDrawer = document.querySelector(
        '#cart-drawer-section cart-drawer-component'
      ) || document.querySelector('#cart-drawer cart-drawer-component');

      if (!incomingDrawer || !currentDrawer) {
        throw new Error('Could not find the Horizon cart drawer components.');
      }

      // Keep Horizon's existing drawer and dialog alive.
      // Replace only their contents with the latest Shopify-rendered markup.
      currentDrawer.innerHTML = incomingDrawer.innerHTML;

      // Recalculate the drawer layout after its contents have changed.
      requestAnimationFrame(() => {
        const dialog = currentDrawer.closest('dialog');
        const content = dialog?.querySelector('.cart-drawer__content');
        const summary = dialog?.querySelector('.cart-drawer__summary');

        if (dialog && content && summary) {
          const ratio =
            summary.getBoundingClientRect().height /
            Math.max(dialog.getBoundingClientRect().height, 1);

          dialog.setAttribute(
            'cart-summary-sticky',
            ratio > 0.5 ? 'false' : 'true'
          );
        }
      });

      document.dispatchEvent(new CustomEvent('xb:cart-synced'));
    } catch (error) {
      console.warn('[XB cart sync] Could not refresh cart drawer:', error);
    } finally {
      refreshInProgress = false;

      if (refreshAgain) {
        refreshAgain = false;
        scheduleRefresh();
      }
    }
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCartDrawer, 150);
  }

  // XB uses fetch() to add its recommended product.
  // Observe the request without changing its payload or response.
  const originalFetch = window.fetch;

  window.fetch = function (...args) {
    const result = originalFetch.apply(this, args);

    try {
      const request = args[0];
      const rawUrl =
        typeof request === 'string' || request instanceof URL
          ? request.toString()
          : request.url;

      const requestUrl = new URL(rawUrl, window.location.href);

      if (
        requestUrl.origin === window.location.origin &&
        ADD_URL.test(requestUrl.pathname + requestUrl.search) &&
        requestUrl.searchParams.get('fn') === 'fsbu'
      ) {
        result.then((response) => {
          if (response.ok) scheduleRefresh();
        }).catch(() => {});
      }
    } catch (error) {
      console.warn('[XB cart sync] Could not inspect request:', error);
    }

    return result;
  };
})();
